module.exports = __webpack_public_path__ + "img/bh-violet.fd3eb920.png";